import React from 'react';

import { FormatHelper } from '@adp-wfn/mdf-core';
import { SdfExpandableBox } from '@waypoint/react-components';
import { MDFIcon } from '../MDFIcon';

export interface IWFNXCollapsibleCardProps {
  children?: React.ReactNode;
  className?: string;
  collapsed?: boolean;
  collapsible?: boolean;
  headerClass?: string;
  iconClass?: string;
  title: string;
  onCollapse?: () => void;
  onExpand?: () => void;
}

export class WFNXCollapsibleCard extends React.Component<IWFNXCollapsibleCardProps, any> {
  constructor(props) {
    super(props);
  }

  private onCollapse = () => this.props.onCollapse?.();
  private onExpand = () => this.props.onExpand?.();

  render() {
    const { className, collapsed, headerClass, iconClass, title } = this.props;
    const props: any = {
      collapseLabel: FormatHelper.formatMessage('@@CollapseCard'),
      expandLabel: FormatHelper.formatMessage('@@ExpandCard'),
      triggerPlacement: 'after',
      variant: 'shadowed',
      onSdfOpen: this.onExpand,
      onSdfClose: this.onCollapse
    };

    if (className) {
      props.className = className;
    }

    if (title && !(headerClass || iconClass)) {
      props.header = title;
    }

    if (!collapsed) {
      props.opened = true;
    }

    return (
      <SdfExpandableBox {...props}>
        {(headerClass || iconClass) &&
          <div slot="header" className={headerClass ?? ''}>
            {iconClass && <MDFIcon className={`mr-2 ${iconClass ?? ''}`} />}
            <span className={'text-xl font-bold leading-md tracking-xs'}>{title}</span>
          </div>
        }
        <div className="mt-4 pt-4 border-t-2 border-l-0 border-r-0 border-b-0 border-solid border-dark">
          {this.props.children}
        </div>
      </SdfExpandableBox>
    );
  }
}
